import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import {
  FacebookTargetingCategory,
  FacebookTargetingType,
} from "../../../../shared/models/facebookTargeting";
import { HttpClient } from "../../../../shared/services/http-client";

@Injectable()
export class FacebookTargetingService {
  constructor(
    private http: HttpClient,
    private readonly translateService: TranslateService,
  ) {}

  getFacebookTargetingCategories(): Observable<FacebookTargetingCategory[]> {
    return this.http
      .get(`facebook/targeting_categories`)
      .pipe(
        map(({ body }) =>
          body.map(
            (data: any) =>
              new FacebookTargetingCategory(
                data.name,
                data.code,
                data.type,
                data.classType,
              ),
          ),
        ),
      );
  }

  getFacebookTargetingTypes(
    type: string,
    key: string,
    classType: string,
  ): Observable<FacebookTargetingType[]> {
    const locale: string = this.translateService.currentLang;
    return this.http
      .get(
        `facebook/targeting?type=${type}&key=${key}&class=${classType}&locale=${locale}`,
      )
      .pipe(
        map(({ body }) =>
          body.map(
            (data: any) =>
              new FacebookTargetingType(data.name, data.id, data.type),
          ),
        ),
      );
  }

  getInterestsList(ids: string[]): Observable<FacebookTargetingType[]> {
    const locale: string = this.translateService.currentLang;
    return this.http
      .get(
        `facebook/interests_list?ids[]=${ids.join("&ids[]=")}&locale=${locale}`,
      )
      .pipe(
        map(({ body }) =>
          body.map(
            (data: any) =>
              new FacebookTargetingType(data.name, data.id, data.type),
          ),
        ),
      );
  }
}
